import { useCallback, useEffect, useState } from 'react';
import { normalizeQuery, matchesQuery } from '../../shared/textMatch';

/**
 * The single search query for one client's page: it filters what is already loaded
 * (Activity, Work items, Requests) and nothing else — not the shell's global search.
 * Resets when the client changes.
 *
 * @param {string} clientId
 * @returns {{query:string, setQuery:(q:string)=>void, active:boolean, clear:()=>void,
 *   matches:(...fields:any[])=>boolean, label:string}}
 */
export default function useClientSearch(clientId) {
  const [query, setQuery] = useState('');
  useEffect(() => { setQuery(''); }, [clientId]);
  const clear = useCallback(() => setQuery(''), []);
  const active = normalizeQuery(query) !== '';
  return {
    query, setQuery, active, clear,
    matches: (...fields) => matchesQuery(query, ...fields),
    label: query.trim(),
  };
}
